<template lang="pug">
  .container-dialog(id="SetPlayListItemSynchroProperties-container")
    el-switch(id="SetPlayListItemSynchroProperties-sendListenSwitch" v-model='visibleFormSendMarker', :active-text='$t("Send")', :inactive-text='$t("Listen")')
    .div(v-if='visibleFormSendMarker')
      p {{ $t('Send synchro marker as soon as playing started')}}
      el-form(v-on:submit.native.prevent="saveNewBroadcastSynchroMaker()",
        label-width="150px",
        :inline="true",
        id="SetPlayListItemSynchroProperties-sendSynchroMarkerForm"
      )
        el-form-item
          span.label {{ $t('IP') }}
          el-input(id="SetPlayListItemSynchroProperties-ipInput" v-model="broadcastSynchronize.address", type="text", placeholder="IP")
        el-form-item
          span.label {{ $t('Message') }}
          el-input(id="SetPlayListItemSynchroProperties-messageInput" v-model="broadcastSynchronize.name", type="text", placeholder="name")
    .div(v-if='!visibleFormSendMarker')
      p {{ $t('Start playing upon receiving synchronization marker')}}
      el-form(v-on:submit.native.prevent="saveListenToSynchroMarker()",
        label-width="150px",
        status-icon=true,
        :inline="true",
        :size="uxParam('formSize')",
        id="SetPlayListItemSynchroProperties-listenToMarkerForm"
      )
        el-form-item
          el-select(
            id="SetPlayListItemSynchroProperties-markerSelect",
            v-model='listenSynchronize',
            filterable,
            default-first-option,
            allow-create,
            placeholder='Select marker',
            style="width:570px;")
            el-option(v-for='item in playItemsWithMarkers', :id="'SetPlayListItemSynchroProperties-markerOption' + item.id", :key='item.id', :label='printMarkerBreadcrumb(item)', :value='item.marker')
        el-form-item
    el-button-group.float-right
      el-button(
        v-if='!visibleFormSendMarker',
        id="SetPlayListItemSynchroProperties-submitListenToMarkerButton"
        type="success",
        :disabled="isSaving || !listenSynchronize",
        size="mini",
        @click="saveListenToSynchroMarker()",
      )
        font-awesome-icon(icon="save")
        span &nbsp; {{$t(buttonListenMarkerText())}}
      //- el-switch(v-model='visibleFormSendMarker', :active-text='$t("Send marker")', :inactive-text='$t("Listen to marker")')
      el-button.float-right(
        v-if='visibleFormSendMarker'
        id="SetPlayListItemSynchroProperties-submitSendSynchroMarkerButton",
        type="success",
        :disabled="isSaving || !newBroadcastMarkerDataExist",
        size="mini",
        @click="saveNewBroadcastSynchroMaker()",
      )
        font-awesome-icon(icon="save")
        span &nbsp; {{$t(buttonNewMarkerText())}}
      el-button(id="SetPlayListItemSynchroProperties-clearButton" type="success", size="mini", @click="clearSynchroMaker()")
        span {{$t('Clear')}}&nbsp;
        font-awesome-icon.icon(icon="trash")
    .errors(v-if="errors.length > 0")
      .error(v-for="error in errors")
        p {{ error }}
</template>

<script>
import Vue from 'vue'
export default {
  props: ['playListItem', 'playList'],
  async created () {
    if (this.playListItem.broadcastSynchronize && JSON.parse(this.playListItem.broadcastSynchronize)) this.visibleFormSendMarker = true
    await this.loadData()
    this.listenSynchronize = this.playListItem.listenSynchronize ? JSON.parse(this.playListItem.listenSynchronize).name : ''
  },
  data () {
    return {
      errors: [],
      broadcastSynchronize: this.playListItem.broadcastSynchronize ? JSON.parse(this.playListItem.broadcastSynchronize) : { name: '', address: '224.0.0.9' },
      selectedMarkerGroup: undefined,
      synchroMarkersInGroup: [],
      deviceDesktopGroups: [],
      playItemsWithMarkers: [],
      isSaving: false,
      visibleFormSendMarker: false,
      selectedMarker: undefined,
      listenSynchronize: undefined
    }
  },
  watch: {
    visibleFormSendMarker (oldVal, newVal) {
      this.errors = []
    }
  },
  methods: {
    printMarkerBreadcrumb (marker) {
      if (marker.devicedesktopgroupname) {
        return `${marker.devicedesktopgroupname}/${marker.devicename}/${marker.devicedesktopname}/${JSON.parse(marker.broadcastSynchronize).name}@${JSON.parse(marker.broadcastSynchronize).address}`
      } else {
        return `${marker.localplaylistname}/${JSON.parse(marker.broadcastSynchronize).name}@${JSON.parse(marker.broadcastSynchronize).address}`
      }
    },
    async loadData () {
      let path = `PlayListItem/getBroadcastSynchronizeMarkers`
      await Vue.axios
        .get(path)
        .then(response => {
          this.playItemsWithMarkers = response.data.playItemsWithMarkers
          for (const item of this.playItemsWithMarkers) {
            item.marker = JSON.parse(item.broadcastSynchronize).name
          }
        })
    },
    changeSelectedMarker (marker) {
      this.selectedMarker = marker
    },
    buttonNewMarkerText () {
      if (this.isSaving) return 'saving data...'
      return 'Create Broadcast marker'
    },
    buttonListenMarkerText (type) {
      if (this.isSaving) return 'saving data...'
      return `Listen to marker`
    },
    async __validateInputNewMarker () {
      this.errors = []
      if (!this.broadcastSynchronize.name || !this.broadcastSynchronize.address) {
        this.errors.push(this.$t('Invalid data. Provide unique name and IP address'))
      }
      if (this.errors.length === 0) return true
      return false
    },
    async clearSynchroMaker () {
      this.isSaving = true
      let path = `PlayListItem/${this.playListItem.id}`
      await Vue.axios
        .patch(path, {
          broadcastSynchronize: null,
          listenSynchronize: null
        })
        .then(response => {
          this.broadcastSynchronize = { name: '', address: '' }
          this.$emit('close')
        })
      this.isSaving = false
    },
    async saveNewBroadcastSynchroMaker () {
      if (!await this.__validateInputNewMarker()) return
      this.isSaving = true
      let path = `PlayListItem/${this.playListItem.id}`
      try {
        await Vue.axios
          .patch(path, {
            broadcastSynchronize: this.broadcastSynchronize.name ? JSON.stringify(this.broadcastSynchronize) : null,
            listenSynchronize: null
          })
        this.$emit('close')
      } catch (error) {
        this.isSaving = false
      }
    },
    async saveListenToSynchroMarker (type = 'existing') {
      console.log(this.listenSynchronize)
      const payload = JSON.stringify({
        address: '224.0.0.9',
        name: this.listenSynchronize
      })
      const path = `PlayListItem/${this.playListItem.id}`
      await Vue.axios
        .patch(path, {
          broadcastSynchronize: null,
          listenSynchronize: payload
        })
        .then(response => {
          this.$emit('close')
        })
      this.isSaving = false
    }
  },
  computed: {
    newBroadcastMarkerDataExist () {
      return this.broadcastSynchronize.name && this.broadcastSynchronize.name.length > 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.bolder {
  font-weight: bold;
}
.error {
  color: $--color-warning;
}
.current-marker {
  color: $--color-text-secondary;
}
.label {
  font-size: $--font-size-base;
}
.container-dialog {
  width: 70%;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/SetPlayListItemSynchroProperties.vue